var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFavIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 32,
    viewBox: "0 0 19 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 16.5L2 1L1.5 4.5C1.5 6.1 2.16667 7.16667 2.5 7.5L12 17C14.8 19.8 13.1667 22.1667 12 23L2 28.5C1.2 28.9 1 30.6667 1 31.5L17 22.5C19.4 20.1 18 17.5 17 16.5Z",
    fill: "#0052FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15.5L2 9.5C1.2 10.7 1.66667 12.6667 2 13.5L8 19.5C8.4 17.5 7.83333 16 7.5 15.5Z",
    fill: "#0052FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 20.5L1.5 16C1.1 18 1.66667 19.8333 2 20.5L6 24.5C7.2 22.9 6.5 21.1667 6 20.5Z",
    fill: "#0052FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 16.5L2 1L1.5 4.5C1.5 6.1 2.16667 7.16667 2.5 7.5L12 17C14.8 19.8 13.1667 22.1667 12 23L2 28.5C1.2 28.9 1 30.6667 1 31.5L17 22.5C19.4 20.1 18 17.5 17 16.5Z",
    stroke: "#0052FF",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15.5L2 9.5C1.2 10.7 1.66667 12.6667 2 13.5L8 19.5C8.4 17.5 7.83333 16 7.5 15.5Z",
    stroke: "#0052FF",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6 20.5L1.5 16C1.1 18 1.66667 19.8333 2 20.5L6 24.5C7.2 22.9 6.5 21.1667 6 20.5Z",
    stroke: "#0052FF",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavIcon);
export default __webpack_public_path__ + "static/media/fav_icon.8028fbf9592b6220eab2fc7b4a2ea856.svg";
export { ForwardRef as ReactComponent };